export const FormattingToolbarClassName = 'RichTextField-toolbar';
